export default {"src":"/_next/static/media/logo-societe-generale-vector-white.afe9c25c.svg","height":25,"width":123,"blurWidth":0,"blurHeight":0};